var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { DateTime } from 'luxon';
import { action, makeObservable, observable } from 'mobx';
import { NO_ID } from '../common/ids';
var ClaimsStore = /** @class */ (function () {
    function ClaimsStore(rootStore) {
        var _a, _b, _c;
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: rootStore
        });
        Object.defineProperty(this, "updateCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "startCallCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "openClaimCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "downloadPhotosCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "openCallLogs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isBusy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "countryId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NO_ID
        });
        Object.defineProperty(this, "organizationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NO_ID
        });
        Object.defineProperty(this, "searchText", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "caseTypeCodeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NO_ID
        });
        Object.defineProperty(this, "addressId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NO_ID
        });
        Object.defineProperty(this, "claimsItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "totalClaims", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "pageIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "isFilterPaneVisible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ((_a = localStorage.getItem('is-filter-pane-visible')) !== null && _a !== void 0 ? _a : 'true') === 'true'
        });
        Object.defineProperty(this, "searchMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: parseInt((_b = localStorage.getItem('claims-page-criteria')) !== null && _b !== void 0 ? _b : '1')
        });
        Object.defineProperty(this, "pageSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: parseInt((_c = localStorage.getItem('claims-page-size')) !== null && _c !== void 0 ? _c : '25')
        });
        Object.defineProperty(this, "fromDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable(new Date())
        });
        Object.defineProperty(this, "toDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable(new Date())
        });
        Object.defineProperty(this, "countries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "organizations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "caseTypeCodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        makeObservable(this);
        window.$ClaimsStore = this;
    }
    Object.defineProperty(ClaimsStore.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (claimsItems, totalClaims, countries, organizations, caseTypeCodes, onUpdate, onStartCall, onOpenClaim, onDownloadPhotos, onOpenCallLogs) {
            if (!Array.isArray(claimsItems))
                return;
            // the server sends a null key for the "all" entry
            var withKeys = function (items) { return items.map(function (i) { var _a; return (__assign(__assign({}, i), { key: (_a = i.key) !== null && _a !== void 0 ? _a : NO_ID })); }); };
            countries = withKeys(countries);
            organizations = withKeys(organizations);
            caseTypeCodes = withKeys(caseTypeCodes);
            this.countryId = countries.length === 1 ? countries[0].key : NO_ID;
            this.organizationId = organizations.length === 1 ? organizations[0].key : NO_ID;
            this.caseTypeCodeId = caseTypeCodes.length === 1 ? caseTypeCodes[0].key : NO_ID;
            this.toDate = DateTime.local().endOf('day').toJSDate();
            this.fromDate = DateTime.local().startOf('week').toJSDate();
            this.claimsItems = claimsItems;
            this.totalClaims = totalClaims;
            this.countries = countries;
            this.organizations = organizations;
            this.caseTypeCodes = caseTypeCodes;
            this.updateCallback = onUpdate;
            this.startCallCallback = onStartCall;
            this.openClaimCallback = onOpenClaim;
            this.downloadPhotosCallback = onDownloadPhotos;
            this.openCallLogs = onOpenCallLogs;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "onUpdate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (resetPageIndex) {
            if (this.updateCallback) {
                if (resetPageIndex)
                    this.pageIndex = 0;
                this.isBusy = true;
                this.updateCallback();
            }
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "onStartCall", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseId) {
            if (this.startCallCallback)
                this.startCallCallback(caseId);
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "onOpenClaim", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseId) {
            if (this.openClaimCallback)
                this.openClaimCallback(caseId);
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "onDownloadPhotos", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseId) {
            if (this.downloadPhotosCallback)
                this.downloadPhotosCallback(caseId);
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "onOpenCallLogs", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (callId, ticketId) {
            if (this.openCallLogs)
                this.openCallLogs(callId, ticketId);
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateClaims", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (claimsItems, totalCount) {
            this.claimsItems = claimsItems;
            this.totalClaims = totalCount;
            this.isBusy = false;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateSearchMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (searchMode) {
            this.searchMode = searchMode;
            localStorage.setItem('claims-page-criteria', searchMode.toString());
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updatePageIndex", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (pageIndex) {
            this.pageIndex = pageIndex;
            this.onUpdate(false);
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updatePageSize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (pageSize) {
            this.pageSize = pageSize;
            localStorage.setItem('claims-page-size', pageSize.toString());
            this.onUpdate(true);
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateSelectedCountry", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (countryId) {
            var _this = this;
            this.countryId = countryId;
            if (this.organizationId !== NO_ID) {
                var organization = this.organizations.find(function (o) { return o.key === _this.organizationId; });
                if (organization && organization.filterKey !== this.countryId)
                    this.organizationId = NO_ID;
            }
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateSelectedOrganization", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (organizationId) {
            this.organizationId = organizationId;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateSelectedCaseTypeCode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeCodeId) {
            this.caseTypeCodeId = caseTypeCodeId;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateSelectedAddress", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (addressId) {
            this.addressId = addressId;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateFromDate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fromDate) {
            this.fromDate = fromDate;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateToDate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (toDate) {
            this.toDate = toDate;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "updateSearchText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (searchText) {
            this.searchText = searchText ? searchText.trim() : '';
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "setClaimExpanded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id, expand) {
            var claim = this.claimsItems.find(function (c) { return c.id === id; });
            if (claim)
                claim.isExpanded = expand;
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "setAllClaimsExpanded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (expand) {
            this.claimsItems.forEach(function (c) { return c.isExpanded = expand; });
        }
    });
    Object.defineProperty(ClaimsStore.prototype, "setIsFilterPaneVisible", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (visible) {
            this.isFilterPaneVisible = visible === true;
            localStorage.setItem('is-filter-pane-visible', this.isFilterPaneVisible.toString());
        }
    });
    __decorate([
        observable
    ], ClaimsStore.prototype, "isBusy", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "countryId", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "organizationId", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "searchText", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "caseTypeCodeId", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "addressId", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "claimsItems", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "totalClaims", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "pageIndex", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "isFilterPaneVisible", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "searchMode", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "pageSize", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "fromDate", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "toDate", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "countries", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "organizations", void 0);
    __decorate([
        observable
    ], ClaimsStore.prototype, "caseTypeCodes", void 0);
    __decorate([
        action
    ], ClaimsStore.prototype, "init", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "onUpdate", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateClaims", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateSearchMode", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updatePageIndex", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updatePageSize", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateSelectedCountry", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateSelectedOrganization", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateSelectedCaseTypeCode", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateSelectedAddress", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateFromDate", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateToDate", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "updateSearchText", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "setClaimExpanded", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "setAllClaimsExpanded", null);
    __decorate([
        action
    ], ClaimsStore.prototype, "setIsFilterPaneVisible", null);
    return ClaimsStore;
}());
export default ClaimsStore;
